/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

import React  from "react";

import Icon from '@material-ui/core/Icon';
import fileTypes from 'config/icons/file-types';

export default class FileTypeIcon extends React.PureComponent {
  render() {
    let extension = this.props.extension;
    let type = this.props.type;
    let size = this.props.size || 48;
    let s = size + "px";
    let typeIcon = fileTypes['file.'+type];

    return (
      <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: "relative",
          width: s,
          height: s
      }}>
          { type && typeIcon ? <Icon color="inherit" fontSize="default">
              {typeIcon}
          </Icon> : null }
          { extension ? <Icon color="inherit" fontSize="large">
              insert_drive_file
          </Icon> : null }
          { extension ? <div
          style={{
            width: s,
            height: "25px",
            fontSize: "11px",
            textTransform: "uppercase",
            textAlign: "center",
            paddingTop: '5px'
          }}
        >
          {extension}
        </div> : null }
      </div>
    );
  }
}
